import React from 'react'
import { Form } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { CompleteInfoState } from 'src/core/models'
import { RegisterCompleteStepChanger } from '../index'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { getCompleteInfoFormSections } from './complete-register.sections'
import { CustomCard, CustomTitle, CustomText, CustomFileInput } from 'src/components'
import {
  completeInfoStatePayloadSelector,
  setCompleteRegisterFormValue,
  completeUserInfo,
} from 'src/features'

const CompleteRegisterFormFiles: React.FC = () => {
  const { t } = useTranslation()
  const { code } = useRouter().query
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const sections = getCompleteInfoFormSections(t)
  const payloadData = useAppSelector(completeInfoStatePayloadSelector)

  const onFinish = async () => {
    const payload = await payloadData
    dispatch(completeUserInfo(String(code), payload))
  }

  const handleChange = (url: string, key: keyof CompleteInfoState) => {
    dispatch(setCompleteRegisterFormValue({ key, value: url }))
  }

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      <CustomCard>
        <CustomTitle label={t('Auth.CompleteInfo.Title2')} type={null} />
        <CustomTitle label={t('Auth.CompleteInfo.Subtitle2')} />

        {sections.map((section, idx) => <div key={idx}>
          <CustomTitle className='label-input' {...section.labelProps} />
          <CustomText label={section.childLabel} type='secondary' />
          <br/><br/>
          <CustomFileInput
            name={section.formProps.name as string}
            onChangeFileUrl={(url: string) => handleChange(url, section.formProps.name)}
            required
          />
        </div>)}
      </CustomCard>

      <RegisterCompleteStepChanger
        nextStepValue={null}
        beforeStepValue={2}
      />
    </Form>
  )
}

export default CompleteRegisterFormFiles
